export const medicalConstants = {
  MEDICAL_LIST: "MEDICAL_LIST",
  LOADING_MEDICAL_LIST: "LOADING_MEDICAL_LIST",
  MEDICAL_ALL: "MEDICAL_ALL"
};
